import { render } from "./FineFatturazioneCard.vue?vue&type=template&id=3fafab4e&scoped=true"
import script from "./FineFatturazioneCard.vue?vue&type=script&lang=js"
export * from "./FineFatturazioneCard.vue?vue&type=script&lang=js"

import "./FineFatturazioneCard.vue?vue&type=style&index=0&id=3fafab4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fafab4e"]])

export default __exports__